import React from 'react';
import { useLocation } from 'react-router-dom';
import { isBlogger } from '../../../utils/accessService';
import { cropPublicId } from '../../../utils/cropPublicId';
import { useBackButton } from '../../../utils/useBackButton';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Avatar } from '../../media/Avatar';
import { Typography } from '../../typography/Typography';
import { UserUI } from '../types';
import { Chevron, ItemContainer } from './styles';

const ICON_SIZE = 24;

export function OtherMenuOptionsDialog() {
    const t = useTranslation();
    const onNavigateBack = useBackButton();

    const { pathname, state } = useLocation();
    const { user } = state as { user: UserUI };
    const profile = user.profile;

    if (!profile) {
        return null;
    }

    const businessProfilePath = profile.url;
    const closeOnCurrentPage = (event: React.MouseEvent, targetPath: string) => {
        const isRegularClick =
            event.button === 0 &&
            !event.metaKey &&
            !event.ctrlKey &&
            !event.shiftKey &&
            !event.altKey;

        if (isRegularClick && pathname === targetPath) {
            event.preventDefault();
            onNavigateBack();
        }
    };

    return (
        <SmartDrawer
            onClose={onNavigateBack}
            mainContent={
                <Box p={1} pt={2} width="100%">
                    {!isBlogger(user?.role) && (
                        <ItemContainer
                            replace
                            to="/profile"
                            onClick={(event) => closeOnCurrentPage(event, '/profile')}
                        >
                            <Flex my={0.5} direction="row" alignItems="center">
                                <Avatar
                                    src={user.avatarUrl}
                                    title={user.displayName}
                                    size={ICON_SIZE}
                                />
                                <Typography color="var(--color-primary)" variant="body" ml={1}>
                                    {t('Профиль')}
                                </Typography>
                            </Flex>
                            <Chevron />
                        </ItemContainer>
                    )}

                    <ItemContainer
                        replace
                        to={businessProfilePath}
                        onClick={(event) => closeOnCurrentPage(event, businessProfilePath)}
                    >
                        <Flex my={0.5} direction="row" alignItems="center">
                            <Avatar
                                src={profile.avatarUrl}
                                title={profile.displayName}
                                size={ICON_SIZE}
                            />
                            <Box>
                                <Typography color="var(--color-primary)" variant="body" ml={1}>
                                    {t(cropPublicId(profile.publicId))}
                                </Typography>
                                <Typography color="var(--color-secondary)" variant="caption" ml={1}>
                                    {profile.isService ? t('бизнес-услуги') : t('бизнес-профиль')}
                                </Typography>
                            </Box>
                        </Flex>
                        <Chevron />
                    </ItemContainer>
                </Box>
            }
        />
    );
}
